import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Clone, Sparkles, useGLTF } from '@react-three/drei';
import { RigidBody } from '@react-three/rapier';

export default function Book({ visible }) {
  const modelBook = useGLTF('../models/book.glb');
  
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const ref5 = useRef();
  const ref6 = useRef();
  const ref7 = useRef();
  const ref8 = useRef();
  const ref9 = useRef();
  const ref10 = useRef();
  const ref11 = useRef();
  const ref12 = useRef();
  const ref13 = useRef();
  const ref14 = useRef();
  const ref15 = useRef();
  const ref16 = useRef();



  const speed1 = 0.01;
  const speed2 = 0.02;
  const speed3 = 0.03;
  const speed4 = 0.04;
  const speed5 = 0.02;
  const speed6 = 0.01;
  
  useFrame(() => {
    if (ref1.current) {
      ref1.current.rotation.y += speed1;
    }
    if (ref2.current) {
      ref2.current.rotation.y += speed2;
    }
    if (ref3.current) {
      ref3.current.rotation.y += speed3;
    }
    if (ref4.current) {
      ref4.current.rotation.y += speed4;
    }
    if (ref5.current) {
      ref5.current.rotation.y += speed5;
    }
    if (ref6.current) {
      ref6.current.rotation.y += speed6;
    }
  });

  return (
    <>
      {visible[0] && (
        <RigidBody ref={ref1} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 0, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-12, 1, -107.5]} />
          <Clone scale={0.7} position={[-12, 0.9, -107.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[1] && (
        <RigidBody ref={ref2} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 1, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-6, -3, -7.5]} />
          <Clone scale={1} position={[-6, -3.5, -7.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[2] && (
        <RigidBody ref={ref3} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 2, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[6, -2.5, -16.5]} />
          <Clone scale={1} position={[6, -3.5, -16.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[3] && (
        <RigidBody ref={ref4} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 3, collected: false }}>
            <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} rotation-z={Math.PI * 2} position={[0, 0.55, -43.5]} />
          <Clone scale={0.7} position={[0, 0.5, -43.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[4] && (
        <RigidBody ref={ref5} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 4, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[7, -2.5, -167.5]} />
          <Clone scale={0.7} position={[7, -3, -167.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[5] && (
        <RigidBody ref={ref6} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 5, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[0, 1.2, -69.5]} />
          <Clone scale={0.7} position={[0, 0.8, -69.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[6] && (
        <RigidBody ref={ref7} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 6, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-1, 0.5, -93.5]} />
          <Clone scale={0.7} position={[-1, 0.1, -93.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[7] && (
        <RigidBody ref={ref8} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 7, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[10, -2.5, -114.5]} />
          <Clone scale={0.7} position={[10, -3, -114.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[8] && (
        <RigidBody ref={ref9} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 8, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-9, -0.3, -174]} />
          <Clone scale={0.7} position={[-9, -0.4, -174]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[9] && (
        <RigidBody ref={ref10} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 9, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[4, -0.1, -258]} />
          <Clone scale={0.7} position={[4, -0.3, -258]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[10] && (
        <RigidBody ref={ref11} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 10, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-8, -2.2, -259.6]} />
          <Clone scale={0.7} position={[-8, -2.2, -259.6]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[11] && (
        <RigidBody ref={ref12} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 11, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-2, 0.7, -197.5]} />
          <Clone scale={0.7} position={[-2, 0.6, -196.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[12] && (
        <RigidBody ref={ref13} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 12, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-2, 0.7, -230.5]} />
          <Clone scale={0.7} position={[-2, 0.6, -230.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[13] && (
        <RigidBody ref={ref14} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 13, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-3, 2.7, -238.5]} />
          <Clone scale={0.7} position={[-3, 2.5, -238.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[14] && (
        <RigidBody ref={ref15} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 14, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[-8, 1.2, -245.5]} />
          <Clone scale={0.7} position={[-8, 1, -245.5]} object={modelBook.scene} />
        </RigidBody>
      )}
      {visible[15] && (
        <RigidBody ref={ref16} type='fixed' colliders="trimesh" userData={{ type: 'book', index: 15, collected: false }}>
          <Sparkles count={30} scale={[1, 1, 1]} size={5} speed={0.2} color="yellow" noise={1} position={[8, -0.7, -239.5]} />
          <Clone scale={0.7} position={[8, -0.5, -239.5]} object={modelBook.scene} />
        </RigidBody>
      )}

      
    </>
  );
}
